import { render, staticRenderFns } from "./CustomRadialChart.vue?vue&type=template&id=2af63c1e&scoped=true&"
import script from "./CustomRadialChart.vue?vue&type=script&lang=js&"
export * from "./CustomRadialChart.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadialChart.vue?vue&type=style&index=0&id=2af63c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af63c1e",
  null
  
)

export default component.exports